<fa-icon [icon]="icon()" [color]="color()" [matTooltip]="tooltip()" matTooltipClass="empathy-icon-tooltip"></fa-icon>
